import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const SSOCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token        = params.get('token');
    const refreshToken = params.get('refreshToken');
    const error        = params.get('error');

    if (error || !token) {
      const messages = {
        saml_disabled:   'SSO is not enabled.',
        saml_no_email:   'Your SSO account has no email address.',
        saml_no_account: 'No account found for your SSO identity. Please contact your administrator.',
        saml_failed:     'SSO authentication failed. Please try again.',
      };
      navigate(`/login?error=${encodeURIComponent(messages[error] || 'SSO login failed.')}`, { replace: true });
      return;
    }

    // Store tokens using the same keys as loginService.js storeSession()
    localStorage.setItem('authToken',    token);
    localStorage.setItem('refreshToken', refreshToken || '');
    localStorage.setItem('userId',       params.get('userId')    || '');
    localStorage.setItem('username',     params.get('username')  || '');
    localStorage.setItem('firstName',    params.get('firstName') || '');
    localStorage.setItem('lastName',     params.get('lastName')  || '');
    localStorage.setItem('roles',        params.get('roles')     || '[]');
    localStorage.setItem('roleId',       params.get('roleId')    || '');

    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography color="text.secondary">Completing sign-in…</Typography>
    </Box>
  );
};

export default SSOCallback;
